import credentialVerification from './CredentialVerification';

export const baseLicenceCredential = {
  verification: credentialVerification('licence'),
  credentialInfo: [
    { name: 'Full name', values: ['Jane Doe'] },
    { name: 'Verification authority', values: ['AHPRA'] },
    { name: 'Profession', values: ['Nurse', 'Doctor'] },
    { name: 'Type', values: ['General'] },
    { name: 'Division', values: ['Division1', 'Division2', 'Division3'] },
  ],
  manageVerificationUrl:
    'https://certsy.com/credentials/ahpra-registration/?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=ahpra-registration',
  deleteVerificationUrl:
    'https://certsy.com/credentials/ahpra-registration/?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=ahpra-registration',
};
